import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

// MOBILE: browsers restore the previous session's scroll offset on reload,
// and a locked document (overflow:hidden + position:fixed) can still be
// scrolled programmatically — so the app loaded ~10% scrolled: top UI pushed
// off-screen, blank strip at the bottom. Kill restoration and pin scroll to 0
// on load (and after load, since some mobile browsers re-apply it late).
if ('scrollRestoration' in history) history.scrollRestoration = 'manual'
window.addEventListener('load', () => {
  window.scrollTo(0, 0)
  setTimeout(() => window.scrollTo(0, 0), 0)
})

/**
 * Application Entry Point
 *
 * Renders <App />, which sets up the providers, the <BrowserRouter>, and the
 * router. All routes are defined in src/router.tsx (explicit <Routes>).
 */

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
